
import { Link } from 'react-router-dom';
import { CircleAlert, MinusCircle, ShieldAlert, Upload } from 'lucide-react';

import { Card, CardHead } from '../../components/ui';
import { placeAddress, rejectionLabel } from './format';
import type { PlacementProposalView } from './types';
import styles from './placement.module.css';

export function GapsPanel({ proposal }: { proposal: PlacementProposalView }) {
  const { unmatched, skipped, rejected, repairReasons } = proposal;
  if (
    unmatched.length === 0 &&
    skipped.length === 0 &&
    rejected.length === 0 &&
    repairReasons.length === 0
  ) {
    return null;
  }

  return (
    <Card>
      <CardHead
        title="Места без вставок"
        actions={
          <span className={styles.panelCount}>
            {unmatched.length} без материала · {skipped.length} по плотности ·{' '}
            {rejected.length + repairReasons.length} отклонено
          </span>
        }
      />

      <div className={styles.gapList}>
        {unmatched.map((gap) => (
          <div key={`gap-${gap.segmentIndex}-${gap.startWord}`} className={styles.gapItem}>
            <CircleAlert size={15} className={styles.bannerIconDanger} />
            <div className={styles.gapMain}>
              <div className={styles.gapTitle}>«{gap.anchorText}»</div>
              <div className={styles.gapWhy}>
                {gap.reason}. Абзац {gap.segmentIndex + 1}, слово №{gap.wordNumber}.
              </div>
              <div className={styles.tried}>
                искали: {[gap.query, ...gap.triedQueries].filter(Boolean).join(' · ') || '–'}
              </div>
            </div>
            <Link
              className={styles.linkBtn}
              to={`/library?q=${encodeURIComponent(gap.query)}`}
              title="Открыть библиотеку с этим запросом"
            >
              <Upload size={13} strokeWidth={1.6} /> Подобрать вручную
            </Link>
          </div>
        ))}

        {skipped.map((skip) => (
          <div
            key={`skip-${skip.segmentIndex}-${skip.startWord}-${skip.reason}`}
            className={styles.gapItem}
          >
            <MinusCircle size={15} strokeWidth={1.5} style={{ flexShrink: 0, marginTop: 2 }} />
            <div className={styles.gapMain}>
              <div className={styles.gapTitle}>«{skip.anchorText}»</div>
              <div className={styles.gapWhy}>
                Убрано правилами плотности: {skip.message}. Абзац {skip.segmentIndex + 1}, слово
                №{skip.wordNumber}.
              </div>
            </div>
          </div>
        ))}

        {[...rejected, ...repairReasons].map((item, index) => {
          const address = placeAddress(item.segmentIndex, item.startWord);
          return (
            <div key={`rejected-${index}-${item.reason}`} className={styles.gapItem}>
              <ShieldAlert size={15} strokeWidth={1.5} style={{ flexShrink: 0, marginTop: 2 }} />
              <div className={styles.gapMain}>
                <div className={styles.gapTitle}>{rejectionLabel(item.reason)}</div>
                {address && <div className={styles.gapWhy}>{address}</div>}
              </div>
            </div>
          );
        })}
      </div>

      {unmatched.length === 0 && (
        <div className={styles.panelFoot}>
          <span className={styles.footHint}>
            Материал нашёлся везде: эти места убраны правилами.
          </span>
        </div>
      )}
    </Card>
  );
}
